const Kits = () => {
	return <h1>Kits</h1>;
  };
  
  export default Kits;